<template>
  <div class="box">
    <div class="title">GUARANTOR CONTRACT</div>
    <div class="list">
      <span>1.</span>
      The Guarantor as defined in “2” below, consents and provides their
      undertaking to the Lender to be recognized as Guarantor on the following
      terms:
      <div class="list_list">
        <span>a.</span>
        The guarantor voluntarily undertakes to guarantee for the borrower’s
        loan application to Kinvest and assumes joint liability. The Guarantor
        confirms their understanding that by being held jointly liable with the
        Borrower, does not prevent the Lender from solely or primarily pursuing
        the Guarantor in the event the Borrower becomes unreachable, unavailable
        or otherwise non-compliant with the terms of the Loan.
      </div>
      <div class="list_list">
        <span>b.</span>
        The guarantor promises to guarantee from the effective date of this
        contract until the borrower fulfills all their obligations to Kinvest
        including but not limited to paying all fees in full.
      </div>
      <div class="list_list">
        <span>c.</span>
        If the borrower breaches the contract such as in respect to overdue
        payments owed to the Lender, the guarantor authorizes Kinvest to deduct
        the guarantor’s deposit to pay.
      </div>
      <div class="list_list">
        <span>d.</span>
        The Guarantor shall not cease to be the Guarantor for puproses of this
        Agreement unless, the Borrower fulfills their obligations under Clause
        1.2. or the Guarantor otherwise obtains the approval of the Lender to
        cease as Guarantor and a replacement Guarantor is appointed and
        registered.
      </div>
      <div class="list_list">
        <span>e.</span>
        Further, The guarantor confirms and warrants that the personal
        information provided is is true and correct, and should the same require
        any correction, undertakes to notify the lender of such correction as
        soon as they are aware of an inconsistency.
      </div>
    </div>
    <div class="list">
      <span>2.</span>
      In light of the forgoing terms, the Guarantor voluntarily provides the
      following data to the Lender for its use and enforcement in accordance
      with the Guarantee Terms and Loan Contract Terms, in relation to the Loan
      applied and issued to the Borrower:
    </div>
    <div class="list_p">
      Guarantor Details
    </div>
    <div class="list_p">Guarantor name: {{ name | GetStr4 }}</div>
    <div class="list_p">Guarantor ID number: {{ IDnumber | GetStr4 }}</div>
    <div class="list_p">Guarantee amount: {{ amount }} shillings</div>
    <div class="list_p">Total Loan Amount: {{ Loanamount }} shillings</div>
    <div class="list_p">
      Guarantee period: {{ period }} {{ IsTest ? "months" : "weeks" }} (period)
    </div>
    <div class="list_p">
      Start and end time: {{ guarantorTime }} - {{ endTime }}
    </div>
    <div class="list_p">Guaranteed account: {{ account | GetStr4 }}</div>
    <div class="list_p">
      Time for the first freezing of the guarantee deposit: {{ guarantorTime }}
    </div>
    <div class="list_p">Unfreezing condition: the secured loan is settled</div>
    <div class="list_p2">Contract signing date: {{ signingdate }}</div>
    <div class="list_p">
      Note: The specific guaranteed information is subject to the actual
      guarantee, and the specific information is subject to the guaranteed plan
      displayed online.
    </div>
    <br /><br />
    <common :IsTest="IsTest"></common>
  </div>
</template>
<script>
import axios from "@/http/axios";
import common from "@/compent/common";
export default {
  data() {
    return {
      name: "",
      IDnumber: "",
      amount: "",
      Loanamount: "",
      period: "",
      account: "",
      signingdate: "",
      endTime: "",
      guarantorTime: "",
      IsTest: true,
    };
  },
  filters: {
    GetStr4(str) {
      let t = "",
        len = str.length;
      if (len < 4 || len == 4) {
        t = str;
      } else {
        for (let i = 0; i < len; i++) {
          if (len - i > 4) {
            t += "*";
          } else {
            t += str[i];
          }
        }
      }
      return t;
    },
  },
  created() {
    let o = this.$route.query;
    sessionStorage.setItem("token", o.token);
    axios
      .post("/api/appgateway/loan/getMortgageContract", {
        groupId: o.groupId,
        loanId: o.loanId,
      })
      .then((res) => {
        if (res.code == "00000") {
          const o = res.data;
          this.name =
            o.userkyc.firstName +
            " " +
            o.userkyc.middleName +
            " " +
            o.userkyc.lastName;
          this.IDnumber = o.userkyc.idNumber;
          this.amount = o.guarantor.cautionMoney;
          this.Loanamount = o.userLoan.totalDue;
          this.signingdate = o.userLoan.createTime;
          this.period = o.loanProduct.numberOfInstallments;
          this.account = o.groupAccno;
          this.guarantorTime = o.guarantor.createTime;
          if (o.repaymentPlans && o.repaymentPlans.length > 0) {
            let len = o.repaymentPlans.length - 1;
            this.endTime = o.repaymentPlans[len].dueDate;
          } else {
            this.endTime = "Pending";
          }
        }
      });
    axios.post("/api/appgateway/user/getUserInfo", {}).then((res) => {
      if (res.code == "00000") {
        this.IsTest = res.data.userType == "99";
      }
    });
  },
  components: {
    common,
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.box {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
  padding: 20px 4%;
  box-sizing: border-box;
  .title {
    font-family: "rb";
    font-weight: bold;
    color: #333333;
    line-height: 28px;
    z-index: 2;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .list {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 10px;
    padding-left: 20px;
    position: relative;
    color: #333333;
    font-family: "rr";
    span {
      position: absolute;
      left: 0;
      top: 0;
    }
    .list_list {
      margin-top: 10px;
      position: relative;
      padding-left: 20px;
      span {
        position: absolute;
      }
    }
  }
  .list_p,
  .list_p2 {
    font-family: "rr";
    font-size: 14px;
    color: #333333;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .list_p2 {
    margin: 20px 0;
  }
}
</style>
